import { Filter } from 'framework/list';

const signatureRequiredFilter: Filter = {
  isSignatureRequired: {
    eq: true,
  },
};

export const mergeComplianceReportFilter = (filter?: Filter): Filter => ({
  ...filter,
  ...signatureRequiredFilter,
});
